import { IS_PRODUCTION } from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/constants'

/** Mirrors `isDevFlagsEnabled` in shared-app-logic; the two conditions have to stay in step. */
export const areDevToolsAvailable = (): boolean => (typeof __DEV__ !== 'undefined' && __DEV__) || !IS_PRODUCTION
